import { RequestQuery } from 'common';

import type { InternalQuotesOverviewQueryParams } from './types';

/** Prefix for refetch/invalidate; matches all internal quotes overview queries. */
export const getInternalQuotesOverviewQueryKeyPrefix = () =>
  ['quotes', 'internalQuotesOverview'] as const;

export type InternalQuotesOverviewQueryKeyPrefixType = ReturnType<
  typeof getInternalQuotesOverviewQueryKeyPrefix
>;

export type InternalQuotesOverviewQueryKeyType = [
  ...InternalQuotesOverviewQueryKeyPrefixType,
  RequestQuery<InternalQuotesOverviewQueryParams> | undefined,
];

export const getInternalQuotesOverviewQueryKey = (
  query?: RequestQuery<InternalQuotesOverviewQueryParams>,
): InternalQuotesOverviewQueryKeyType => [
  ...getInternalQuotesOverviewQueryKeyPrefix(),
  query,
];
